import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IEmptyResult } from '../../../httpClient/serverApi/types/IResponse';
export interface ISetDatasourceCertificationParams {
  id: string;
  isCertified: boolean;
  certificationNote: string;
}

export class SetDatasourceCertificationRequest extends Request<ISetDatasourceCertificationParams, IEmptyResult> {
  constructor(params: ISetDatasourceCertificationParams) {
    super('setDatasourceCertification', params);
  }
}
